// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-multiline-js
import { Button, ColumnDefinition, Cooltip, Cursor, Icon, Modal, Tab, Table, TabPanel } from '@abb/common-ux';
import { ReqApprovalRejectionModel } from '@module/analysis/RequestLogDetails/ReqApprovalRejectionModel';
import { TakeOwnershipConfirmationModel } from '@module/analysis/RequestLogDetails/TakeOwnershipConfirmationModel';
import { IUserToken } from '@module/authentication/models';
import { ICountry, IMatchedSpareParts, IRequestReportDetails, ISite, RequestReportDetails } from '@module/shared';
import { MySparePartsDonut } from '@module/shared/components/Donut/MySparePartsDonut';
import { Waiting } from '@module/shared/components/Waiting';
import { FetchCountries } from '@service/CountryService';
import { DownloadReport } from '@service/DownloadTemplateService';
import { approveRejectDetailedReportRequest, AssignSite, DeleteSite, GetRequestDetailsByRequestId, GetSite, SubmitToPartsManager, TakeOwnership } from '@service/RequestDetailsService';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { IConnectedComponent } from 'reducers';
import { AssignSiteModal } from './AssignSiteModal';
import './RequestLogDetails.scss';
import { SubmitRequestModal } from './SubmitRequestModal';
import { SubmitSalesLead } from './SubmitSalesLead';

export interface IRequestLogDetailState {
  requestDetails: IRequestReportDetails;
  approvalRejectionModelDisplay: boolean;
  approveRequestBit: boolean;
  finalizedCommentsByPartsSpec: string;
  confirmationModelOpen: boolean;
  isLoadingForTakeOwnershipModel: boolean;
  showProgress: boolean;
  showSiteModal: boolean;
  showSiteClearModal: boolean;
  showUploadPartsModal: boolean;
  waiting: boolean;
  countries: any[];
}

export interface IRequestLogDetailProps {
  loggedInUser: IUserToken;
}

class RequestLogDetailsComponent extends React.Component<IConnectedComponent & IRequestLogDetailProps, IRequestLogDetailState> {

  constructor(props: any) {
    super(props);
    this.state = {
      requestDetails: new RequestReportDetails(),
      approvalRejectionModelDisplay: false,
      approveRequestBit: false,
      finalizedCommentsByPartsSpec: '',
      confirmationModelOpen: false,
      isLoadingForTakeOwnershipModel: false,
      showProgress: true,
      showSiteModal: false,
      showSiteClearModal: false,
      showUploadPartsModal: false,
      waiting: false,
      countries: []
    };
  }

  async componentDidMount() {
    await this.getRequestDetail();
    FetchCountries().then((countries: ICountry[]) => {
      this.setState({countries});
    });
  }

  getRequestDetail = async () => {
    const dispatch = this.props.dispatch;
    try {
      const requestDetail = await GetRequestDetailsByRequestId(this.props.loggedInUser, this.props.match.params.requestId);
      this.setState({ requestDetails: requestDetail, showProgress: false });
    } catch (error) {
      if (error.status === 475) {
        dispatch({ type: 'ADD_BANNER', banners: [{id: 'getRequestLogError', bannerType: 'error', children: <span>You have no permissions to use mySpareParts Analyzer. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Summary%20Details%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
      } else {
        dispatch({ type: 'ADD_BANNER', banners: [{id: 'getRequestLogError', bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Summary%20Details%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
      }      
      console.error(`System error: ${error.status} ${error.statusText}`);
    }
  }

  render() {
    const SparePartColumn = ColumnDefinition as new () => ColumnDefinition<IMatchedSpareParts>;
    const allowSiteChange = (!this.state.requestDetails.leadGenerated && !this.state.requestDetails.inventoryUploaded && this.state.requestDetails.statusName !== 'Rejected');

    const assignSiteStyle: React.CSSProperties = this.state.showProgress ?
      { cursor: 'not-allowed', color: '#ABD4FD', textAlign: 'center' } :
      { cursor: 'pointer', color: '#0C74DA', textAlign: 'center' };

    const siteButtonStyle: React.CSSProperties = allowSiteChange ?
       { cursor: 'pointer', color: '#0C74DA', float: 'right' } :
       { cursor: 'not-allowed', color: 'rgba(15, 15, 15, 0.5)', float: 'right' };

    const takeOwnership = this.renderTakeOwnership();
    const approveOrReject = this.renderApproveOrReject();
    const updateInventory = this.renderInventoryUpdate();
    const statusMessage = this.selectStatusMessage();
    const prohibitSiteEdit = this.isSiteEditProhibited();

    const submitSalesLead = (
      <SubmitSalesLead 
        user={this.props.loggedInUser}
        dispatch={this.props.dispatch}
        requestDetails={this.state.requestDetails}
        updateLeadGeneratedInRequestDetails={this.updateLeadGeneratedInRequestDetails} />
    );

    return (
      <div>
        <Waiting isOpen={this.state.waiting} />
        <div className='row '>
          <div className='col-lg-6'>
            <ol className='breadcrumb'>
              <li><Link to={{ pathname: '/requests', state: { fromRequestLogDetails: true} }}>Request Log</Link></li>
              <li className='active' id='workOrderId'>Request #{this.state.requestDetails.requestID || ''}</li>
            </ol>
          </div>
        <div className='col-lg-3'/>
        </div>
        <div className='row'>
          <div className='col-sm-6'>
            <Cursor cursorSize={2} cursorClassName='cursorStyle'>
              Request Summary
            </Cursor>
          </div>
          <div className='col-sm-6 text-right'>
            {updateInventory}{submitSalesLead}{approveOrReject}{takeOwnership}
          </div>
          <div className='col-sm-6 text-right' style={{ paddingTop: '10px' }}>
            {statusMessage}
          </div>
        </div>
        <br/>
        <div className='requestSummaryDisplay'>
          <div className='row display-flex'>
            <div className='col-sm-3 borderRight'>
              <h4>Contact Information</h4>
              <br/>
              <div className='row'>
                <div className='col-sm-6'>
                  <p>Contact Name</p>
                  <p className='boldText'>{this.state.requestDetails.contactName}</p>
                  <br/>
                  <p>Email Address</p>
                  <p className='boldText'>{this.state.requestDetails.contactEmail}</p>
                  <br/>
                  <p>Company Name</p>
                  <p className='boldText'>{this.state.requestDetails.companyName}</p>
                  <br/>
                  <p>Location</p>
                  <p className='boldText'>{this.state.requestDetails.location}</p>
                </div>
                <div className='col-sm-6'>
                  <p>Country</p>
                  <p className='boldText'>{this.state.requestDetails.country}</p>
                  <br/>
                  <p>Postal Code</p>
                  <p className='boldText'>{this.state.requestDetails.postalCode}</p>
                  <br/>
                  <p>Phone Number</p>
                  <p className='boldText'>{this.state.requestDetails.phoneNumber}</p>
                </div>
              </div>
            </div>
            <div className='col-sm-3 borderRight'>
              {this.state.requestDetails.associatedSite ?
                <React.Fragment>
                  <h4>
                    Site Details
                    <div style={{...siteButtonStyle, marginRight: 10}} onClick={!prohibitSiteEdit ? this.toggleSiteClearModal : undefined}>
                      <Cooltip tooltipContents={<span>Remove</span>} tooltipType='default' placement='bottom'>
                        <Icon icon='trash' />
                      </Cooltip>
                    </div>
                    <Modal header='Remove assigned Site' isOpen={this.state.showSiteClearModal} onClose={this.toggleSiteClearModal} modalClassName='clearAssignedSiteModal'>
                      <div className='row'>
                        <div className='col-sm-12'>
                          Are you sure you want to remove the assigned Site?
                        </div>
                      </div>
                      <br />
                      <div className='row'>
                        <div className='col-sm-offset-6 col-sm-3'>
                          <Button
                            buttonType='normal'
                            buttonSize='small'
                            style={{ width: '100%' }}
                            onClick={this.toggleSiteClearModal}
                          >Cancel</Button>
                        </div>
                        <div className='col-sm-3'>
                          <Button
                            buttonType='primary'
                            buttonSize='small'
                            style={{ width: '100%' }}
                            onClick={this.onClearConfirmClick}
                          >Confirm</Button>
                        </div>
                      </div>
                    </Modal>
                    <div style={{...siteButtonStyle, marginRight: 10}} onClick={!prohibitSiteEdit ? this.toggleSiteModal : undefined}>
                      <Cooltip tooltipContents={<span>Edit</span>} tooltipType='default' placement='bottom'>
                        <Icon icon='edit' />
                      </Cooltip>
                    </div>
                  </h4>
                  <br/>
                  <div className='row'>
                    <div className='col-sm-6'>
                      <p>Site</p>
                      <p className='boldText'>{this.state.requestDetails.associatedSite.siteName}</p>
                      <br/>
                      <p>ServIS ID</p>
                      <p className='boldText'>{this.state.requestDetails.associatedSite.servIsId}</p>
                      <br/>
                      <p>City</p>
                      <p className='boldText'>{this.state.requestDetails.associatedSite.city}</p>
                      <br/>
                      <p>Country</p>
                      <p className='boldText'>{this.state.requestDetails.associatedSite.country}</p>
                    </div>
                    <div className='col-sm-6'>
                      <p>Owner</p>
                      <p className='boldText'>
                        {this.state.requestDetails.associatedSite.ownerId ?
                        `${this.state.requestDetails.associatedSite.ownerId} - ${this.state.requestDetails.associatedSite.ownerName}` :
                        this.state.requestDetails.associatedSite.ownerName}
                      </p>
                      <br/>
                      <p>Operator</p>
                      <p className='boldText'>
                        {this.state.requestDetails.associatedSite.operatorId ?
                        `${this.state.requestDetails.associatedSite.operatorId} - ${this.state.requestDetails.associatedSite.operatorName}` :
                        this.state.requestDetails.associatedSite.operatorName}
                      </p>
                      <br/><br/><br/><br/><br/>
                      <p>
                        <span className='viewLink'>
                          <a target='_blank' href={`${environmentSettings.partsManagerUrl}/Site/${this.state.requestDetails.associatedSite ? this.state.requestDetails.associatedSite.servIsId : ''}`}>View Site in mySpareParts Manager</a>
                        </span>
                      </p>
                    </div>
                  </div>
                </React.Fragment> :
                <React.Fragment>
                  <h4>Site Details</h4>
                  <br/>
                  <br/>
                  <br/>
                  <div style={assignSiteStyle} onClick={this.state.showProgress ? undefined : this.toggleSiteModal}><Icon icon='plus_in_circle'/> Assign a Site</div>
                </React.Fragment>
              }
              <AssignSiteModal
                isOpen={this.state.showSiteModal}
                site={this.state.requestDetails.associatedSite}
                onClose={this.toggleSiteModal}
                onAddClick={this.onAddClick}
                onConfirmClick={this.onConfirmClick}
              />
            </div>
            <div className='col-sm-2 borderRight'>
              <h4>Survey Summary</h4>
              <br/>
              <p>
                <span>Condition &amp; Location </span>
                <Cooltip tooltipType='default' tooltipContents={<span>Do you know the condition and location of all of your spare parts?</span>} placement='topLeft' >         
                  <Icon icon='information_circle2' color='#87d2ff' />
                </Cooltip>
              </p>
              <p className='boldText'>{this.state.requestDetails.condition}</p>
              <br/>
              <p>
                <span>Downtime </span>
                <Cooltip tooltipType='default' tooltipContents={<span>Have you had downtime from missing or failed parts?</span>} placement='topLeft' >
                  <Icon icon='information_circle2' color='#87d2ff' />
                </Cooltip>
              </p>
              <p className='boldText'>{this.state.requestDetails.downtime}</p>
              <br/>
              <p>
                <span>Static &amp; Sealed Boxes </span>
                <Cooltip tooltipType='default' tooltipContents={<span>Are your spare parts kept in sealed static bags and / or sealed boxes?</span>} placement='topLeft' >
                  <Icon icon='information_circle2' color='#87d2ff' />
                </Cooltip>
              </p>
              <p className='boldText'>{this.state.requestDetails.storage}</p>
              <br/>
              <p>
                <span>Program Familiarity </span>
                <Cooltip tooltipType='default' tooltipContents={<span>Are you aware of all the options and programs ABB has available for spare parts?</span>} placement='topLeft' >
                  <Icon icon='information_circle2' color='#87d2ff' />
                </Cooltip>
              </p>
              <p className='boldText'>{this.state.requestDetails.awareness}</p>
            </div>
            <div className='col-sm-2'>
              <h4>Parts Information</h4>
              <br/>
              <div className='row'>
                <div className='col-sm-6'>
                  <p>
                    <span>Submitted </span>
                    <Cooltip tooltipType='default' tooltipContents={<span>Unique parts identified.</span>} placement='topLeft' >
                      <Icon icon='information_circle2' color='#87d2ff' />
                    </Cooltip>
                  </p>
                  <p className='boldText'>{this.state.requestDetails.matchedParts.length + this.state.requestDetails.unMatchedParts.length}</p>
                  <br/>
                  <p>Uploaded</p>
                  <p className='boldText'>{moment(this.state.requestDetails.uploaded).format('MM/DD/YYYY HH:mm:ss')}</p>
                  <br/>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <p>ABB Parts Specialist</p>
                  <p className='boldText'>{this.state.requestDetails.partsSpecialistName}</p>
                  <br/>
                  <p>Email Address</p>
                  <p className='boldText'>{this.state.requestDetails.partsSpecialistEmail}</p>
                </div>
              </div>
            </div>
            <div className='col-sm-2' style={{ height: 225 }}>
              <MySparePartsDonut matched={this.state.requestDetails.matchedParts.length}
                unmatched={this.state.requestDetails.unMatchedParts.length}
                circleFill='#f5f5f5'/>
            </div>
          </div>
        </div>
        <br/>
        <div className='row'>
          <div className='col-xs-8'><h4>Spare Parts Analysis</h4></div>
          <div className='col-xs-4 text-right'>
            {this.state.requestDetails.statusName.toLowerCase() === 'approved'
              ? <Button className='blue-btn' buttonType='primary' buttonSize='default' onClick={this.downloadReport}>Download</Button>
              : null }
          </div>
        </div>
        <br/>
        <div className='row' style={{marginBottom: '20px'}}>
          <div className='container-fluid'>
            <Tab selected={0}>
              <TabPanel index={0} label={'Matched (' + this.state.requestDetails.matchedParts.length + ')'}>
                <div className='row'>
                  <div className='col-lg-12'>
                    <Table isLoading={this.state.showProgress} data={this.state.requestDetails.matchedParts} fixedHeader={true}>
                      <SparePartColumn
                        cell={row => row.partNumber.toString()}
                        header='PART NUMBER'
                        columnName='partNumber'
                        columnWidth={1}
                      />
                      <SparePartColumn
                        cell={this.renderPartDescription}
                        header='ABB DESCRIPTION'
                        columnName='description'
                        columnWidth={2}
                      />
                      <SparePartColumn
                        cell={row => row.replacementPartNumber}
                        header='REPLACED BY'
                        columnName='replacementPart'
                        columnWidth={1}
                      />
                      <SparePartColumn
                        cell={row => row.quantity.toString()}
                        header='QUANTITY'
                        columnName='quantity'
                        columnWidth={1}
                      />
                      <SparePartColumn
                        cell={row => <div><span><Icon icon='warning_triangle' color='red' size='small' visibility={row.riskLevel === 'High' ? 'visible' : 'hidden'} /></span><span>{'  '}{row.riskLevel}</span></div>}
                        header={<div><span>RISK LEVEL </span> <Cooltip tooltipType='default' tooltipContents={<span>High/Medium/Low identifier relative to a business risk of not having part availability.</span>} placement='topLeft' ><Icon icon='information_circle2' color='#87d2ff' /></Cooltip></div>}
                        columnName='riskLevel'
                        columnWidth={1}
                      />
                      <SparePartColumn
                        cell={this.renderLifecycle}
                        header={<div><span>LIFE CYCLE </span> <Cooltip tooltipType='default' tooltipContents={<span>Active/Classic/Limited/Obsolete identifier showing a state within the life-cycle of a part.</span>} placement='topLeft' ><Icon icon='information_circle2' color='#87d2ff' /></Cooltip></div>}
                        columnName='lifeCycle'
                        columnWidth={1}
                      />
                      <SparePartColumn
                        cell={this.renderYesNo('countryStock')}
                        header={<div><span>COUNTRY STOCK </span> <Cooltip tooltipType='default' tooltipContents={<span>Yes/No identifier validating if the part is stocked in an ABB warehouse in the country where the request was originated.</span>} placement='topLeft' ><Icon icon='information_circle2' color='#87d2ff' /></Cooltip></div>}
                        columnName='countryStock'
                        columnWidth={2}
                      />
                      <SparePartColumn
                        cell={this.renderYesNo('replaceable')}
                        header={<div><span>REPLACEABLE </span> <Cooltip tooltipType='default' tooltipContents={<span>Yes/No indicator if replacement has been identified.</span>} placement='topLeft' ><Icon icon='information_circle2' color='#87d2ff' /></Cooltip></div>}
                        columnName='replaceable'
                        columnWidth={2}
                      />
                      <SparePartColumn
                        cell={this.renderYesNo('repairable')}
                        header={<div><span>REPAIRABLE </span> <Cooltip tooltipType='default' tooltipContents={<span>Yes/No identifier validating if a part can be repaired.</span>} placement='topLeft' ><Icon icon='information_circle2' color='#87d2ff' /></Cooltip></div>}
                        columnName='repairable'
                        columnWidth={1}
                      />
                    </Table>
                  </div>
                </div>
              </TabPanel>
              <TabPanel index={1} label={'Unmatched (' + this.state.requestDetails.unMatchedParts.length + ')'}>
              <div className='row'>
                  <div className='col-lg-12'>
                    <Table isLoading={this.state.showProgress} data={this.state.requestDetails.unMatchedParts} fixedHeader={true}>
                      <SparePartColumn
                        cell={row => row.partNumber.toString()}
                        header='PART NUMBER'
                        columnName='partNumber'
                        columnWidth={3}
                      />
                      <SparePartColumn
                        cell={this.renderPartDescription}
                        header='DESCRIPTION'
                        columnName='description'
                        columnWidth={7}
                      />
                      <SparePartColumn
                        cell={row => row.quantity.toString()}
                        header='QUANTITY'
                        columnName='quantity'
                        columnWidth={2}
                      />
                    </Table>
                  </div>
                </div>
              </TabPanel>
            </Tab>
          </div>
        </div>
        <ReqApprovalRejectionModel contactEmail={this.state.requestDetails.contactEmail} requesterName={this.state.requestDetails.contactName} isOpen={this.state.approvalRejectionModelDisplay} onCommentsProvided={this.onCommentsProvided} onClose={this.onConfirmationModelClosed} onApprove={this.approveRequestFinal} onReject={this.rejectRequestFinal} />
        <TakeOwnershipConfirmationModel isLoading={this.state.isLoadingForTakeOwnershipModel} isOpen={this.state.confirmationModelOpen} onClose={this.onConfirmationModelClosed} onSubmit={this.onConfirmationModelSubmit} />
      </div>
    );
  }

  isSiteEditProhibited = () => {
    let prohibited = false;

    const isRejected = (this.state.requestDetails.statusName === 'Rejected');
    const isSalesLeadGenerated = this.state.requestDetails.leadGenerated;
    const isInventoryUploaded = this.state.requestDetails.inventoryUploaded;

    if (isRejected || this.state.showSiteClearModal || this.state.showSiteModal || isSalesLeadGenerated || isInventoryUploaded) {
      prohibited = true;
    }

    return prohibited;
  }

  selectStatusMessage = () => {
    let statusMsg = '';

    const isApproved = (this.state.requestDetails.statusName === 'Approved');
    const isRejected = (this.state.requestDetails.statusName === 'Rejected');
    const isPending = (this.state.requestDetails.statusName === 'Pending');
    const isSiteAssigned = (this.state.requestDetails.siteId !== undefined && this.state.requestDetails.siteId !== null && this.state.requestDetails.siteId !== '');

    if (isRejected) {
      statusMsg = 'Request rejected, no further actions possible';
    } else if (isPending) {
      statusMsg = 'Request pending, you should approve first for further actions or reject';
    } else if (isApproved && !isSiteAssigned) {
      statusMsg = 'Request approved, site assignment is required for further actions';
    }
    
    return statusMsg;
  }

  isUserPartsSpecialist = () => {
    return this.state.requestDetails.partsSpecialistEmail && this.state.requestDetails.partsSpecialistEmail.toLowerCase() === this.props.loggedInUser.profile[environmentSettings.tokenField].toLowerCase();
  }

  renderTakeOwnership = () => {
    let buttonContent = null;

    const isApproved = (this.state.requestDetails.statusName === 'Approved');
    const isRejected = (this.state.requestDetails.statusName === 'Rejected');
    if (isApproved || isRejected || this.isUserPartsSpecialist()) {
      buttonContent = (
        <>
          <span className='iconStyling'><Icon icon='check_mark_circle2' size='small' color='green'/>{'  '}Ownership taken</span>
        </>
      );
    } else {
      buttonContent = (
        <>
          <Button className='action-btn' buttonType='primary' buttonSize='default' disabled={this.state.showProgress} onClick={this.takeOwnership}>Take Ownership</Button>
        </>
      );
    }

    return (
      <React.Fragment>
        {buttonContent}
      </React.Fragment>
    );

  }

  renderApproveOrReject = () => {
  
    let buttonContent = null;

    const isApproved = (this.state.requestDetails.statusName === 'Approved');
    const isRejected = (this.state.requestDetails.statusName === 'Rejected');
    const isPending = (this.state.requestDetails.statusName === 'Pending');

    if (isApproved) {
      buttonContent = (
        <>
          <span className='iconStyling'><Icon icon='check_mark_circle2' size='small' color='green'/>{'  '}Approved</span>
        </>
      );
    } else if (isRejected) {
      buttonContent = (
        <>
          <span className='iconStyling'><Icon icon='error_circle2' size='small' color='red'/>{'  '}Rejected</span>
        </>
      );
    } else if (isPending) {
      buttonContent = (
        <>
          <Button className='action-btn' buttonType='primary' buttonSize='default' disabled={!this.isUserPartsSpecialist()} onClick={this.toggleApprovalRejectionModelDisplay}>Approve or Reject</Button>
        </>
      );
    }
    return (
      <React.Fragment>
        {buttonContent}
      </React.Fragment>
    );
  }

  renderInventoryUpdate = () => {
    let partsManagerContent = <span>Something went wrong</span>;
    const isApproved = (this.state.requestDetails.statusName === 'Approved');
    const isSiteAssigned = (this.state.requestDetails.siteId !== undefined && this.state.requestDetails.siteId !== null && this.state.requestDetails.siteId !== '');
    const inventoryUploaded = this.state.requestDetails.inventoryUploaded;
    const siteHasExistingParts = (this.state.requestDetails.hasExistingParts);
    const reportHasMatchingParts = (this.state.requestDetails.matchedParts.length > 0);
    const inventoryManagedByManager = (this.state.requestDetails.inventorySource || '').toLowerCase() !== 'servicepro';

    const notApprovedOrSiteAssigned = <span><Button className='action-btn' buttonType='primary' buttonSize='default' disabled={true} onClick={this.toggleUploadPartsModal}>Update Inventory</Button></span>;
    const siteHasExistingInventory = <span className='iconStyling'><Icon icon='check_mark_circle2' size='small' color='green'/>{'  '}Inventory Updated</span>;

    // This is the button with a "cool tip".  Whether or not the button is enabled/disabled or what
    // cool tip we show is a function of a combination of states.  Figure it out and then show the button.

    const btnDisabled = (siteHasExistingParts || !reportHasMatchingParts || !inventoryManagedByManager);

    let cooltip = 'Upload part inventory to site';
    if (inventoryManagedByManager) {
      if (!reportHasMatchingParts) {
        cooltip = 'Report does not have any matching parts';
      } else if (siteHasExistingParts) {
        cooltip = 'Site inventory already exists and cannot be updated by this request\'s details';
      }
    } else {
      cooltip = 'Site inventory is managed in Service Pro, and cannot be updated.';
    }

    const updateWithCooltip = (
      <span style={{float: 'right'}} >
        <Cooltip placement='bottomRight' tooltipContents={<span>{cooltip}</span>} tooltipType='info'>
          <span className={btnDisabled ? 'disabledButtonWithCooltipSpan' : ''} data-trigger='hover'>
            <Button className={btnDisabled ? 'disabledButtonWithCooltipButton tall-blue-btn' : 'tall-blue-btn'}
              buttonType='primary' buttonSize='default' disabled={btnDisabled} onClick={this.toggleUploadPartsModal}>Upload Inventory</Button>
          </span>
        </Cooltip>
      </span>
    );

    if (inventoryUploaded) {
      partsManagerContent = siteHasExistingInventory;
    } else if (!isApproved || !isSiteAssigned) {
      partsManagerContent = notApprovedOrSiteAssigned;
    } else if (isApproved && isSiteAssigned) {
      partsManagerContent = updateWithCooltip;
    }

    const submitRequestModal = this.state.requestDetails.statusName  === 'Approved'  && this.state.requestDetails.associatedSite ? 
      (
        <SubmitRequestModal
          isOpen={this.state.showUploadPartsModal}
          site={this.state.requestDetails.associatedSite}
          onClose={this.toggleUploadPartsModal}
          onConfirmClick={this.onConfirmSubmit}
        />
      ) : null;
    return (
      <React.Fragment>
        {partsManagerContent}
        {submitRequestModal}
      </React.Fragment>
    );
  }

  renderPartDescription = (detailedParts: IMatchedSpareParts) => {
    const overlay = (
      <div>
        {detailedParts.description}
      </div>
    );
    return (
      <Cooltip placement='bottom' tooltipContents={overlay} tooltipType='default'>
        <div className='wrapText'>
          {detailedParts.description}
        </div>
      </Cooltip>
    );
  }

  renderLifecycle = (detailedParts: IMatchedSpareParts) => {
    let icon: any = {};
    switch (detailedParts.lifeCycle) {
      case 'Limited':
        icon = <span><Icon icon='warning_circle2' color='orange' size='small' visibility='visible' /></span>;
        break;
      case 'Obsolete':
        icon = <span><Icon icon='warning_triangle' color='red' size='small' visibility='visible' /></span>;
        break;
      default:
        icon = <span><Icon icon='warning_circle2' color='orange' size='small' visibility='hidden' /></span>;
        break;
    }
    return (
      <div>
        {icon}
        <span> {detailedParts.lifeCycle}</span>
      </div>
    );
  }

  renderYesNo = (propertyName: string) => (detailedParts: IMatchedSpareParts) => {
    let icon: any = {};
    switch (detailedParts[propertyName]) {
      case 'No':
        icon = <span><Icon icon='warning_circle2' color='orange' size='small' visibility='visible' /></span>;
        break;
      default:
        icon = <span><Icon icon='warning_circle2' color='orange' size='small' visibility='hidden' /></span>;
    }
    return (
      <div>
        {icon}
        <span> {detailedParts[propertyName]}</span>
      </div>
    );
  }

  toggleSiteClearModal = () => {
    this.setState({ showSiteClearModal: !this.state.showSiteClearModal });
  }

  toggleSiteModal = () => {
    this.setState({ showSiteModal: !this.state.showSiteModal });
  }

  onAddClick = async (servIsId: string) => {
    try {
      const site = await GetSite(this.props.loggedInUser, servIsId);
      const country = this.state.countries.find((c: any) => c.countryID === site.country);
      if (country !== -1) {
        site.country = country.countryName;
      }
      return site;
    } catch (error) {
      if (error.status === 404) {
        return null;
      } else {
        this.props.dispatch({ type: 'ADD_BANNER', banners: [{id: 'getRequestLogError', bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Summary%20Details%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
      }
    }
    return null;
  }

  onClearConfirmClick = async () => {
    await this.onConfirmClick(undefined);
    this.toggleSiteClearModal();
  }

  onConfirmClick = async (site?: ISite) => {
    try {
      const response = site
        ? await AssignSite(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID, site)
        : await DeleteSite(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID);
      this.setState({ requestDetails: {...this.state.requestDetails, associatedSite: site ? site : undefined, siteId: response.servIsId, inventorySource: response.inventorySource, hasExistingParts: response.hasExistingParts }});
      return true;
    } catch (error) {
      this.props.dispatch({ type: 'ADD_BANNER', banners: [{id: 'getRequestLogError', bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Summary%20Details%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
      return false;
    }
  }

  toggleUploadPartsModal = () => {
    this.setState({ showUploadPartsModal: !this.state.showUploadPartsModal });
  }

  onConfirmSubmit = async () => {
    try {
      const response = await SubmitToPartsManager(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID, this.state.requestDetails.associatedSite!.servIsId);
      if (response.siteId.length > 0) {
        this.setState({ requestDetails: {...this.state.requestDetails, siteId: response.siteId, inventoryUploaded: response.inventoryUploaded } });
        if (response.inventoryUploaded) {
          this.props.dispatch({ type: 'ADD_BANNER', banners: [{id: 'requestSubmitSuccess', bannerType: 'success', timeout: 3000, children: <span>Request #{this.state.requestDetails.requestID} has been successfully transferred to mySpareParts Manager. Matched parts have been automatically added to Inventory for site {this.state.requestDetails.associatedSite!.servIsId} - {this.state.requestDetails.associatedSite!.siteName}</span>}] });
        } else {
          this.props.dispatch({ type: 'ADD_BANNER', banners: [{id: 'requestSubmitInvExists', bannerType: 'info', timeout: 10000, children: <span>Request #{this.state.requestDetails.requestID} cannot be transferred to mySpareParts Manager. Inventory for site {this.state.requestDetails.associatedSite!.servIsId} - {this.state.requestDetails.associatedSite!.siteName} already exists and will not be updated automatically.</span>}] });
        }
      }
      return true;
    } catch (error) {
      this.props.dispatch({ type: 'ADD_BANNER', banners: [{id: 'requestSubmitError', bannerType: 'error', children: <span>Something went wrong. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Summary%20Details%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
      return false;
    }
  }

  calculateDateDiff(uploadDate: Date): number {
    return moment.duration(moment(new Date()).diff(uploadDate)).asHours();
  }

  //Take Ownership Flow - Event handlers
  onConfirmationModelSubmit = async () => {
    const dispatch = this.props.dispatch;
    this.setState({isLoadingForTakeOwnershipModel: true});
    try {
      if (await TakeOwnership(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID)) {
        await this.getRequestDetail();
        dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'success', timeout: 3000, children: <span>{' Request reassigned.'}</span> }] });
      }
    } catch (err) {
      dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Take%20Ownership%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
    }
    this.setState({ confirmationModelOpen: false, isLoadingForTakeOwnershipModel: false });
  }

  takeOwnership = () => {
    this.setState({ confirmationModelOpen: true });
  }

  onConfirmationModelClosed = () => {
    this.setState({ confirmationModelOpen: false, approvalRejectionModelDisplay: false });
  }

  //Approval Rejection Flow - Event handlers
  approveRequestFinal = async () => {
    const dispatch = this.props.dispatch;
    try {
      if (await approveRejectDetailedReportRequest(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID, 2, this.state.finalizedCommentsByPartsSpec) === true) {
        dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'success', timeout: 3000, children: <span>{' Request approved.'}</span> }] });
        this.setState(prevState  => ({
          requestDetails: {
            ...prevState.requestDetails, 
            statusName: 'Approved'
          }
        }));
      }
    } catch (err) {
      dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Approve%20Request%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
    }
    this.setState({approvalRejectionModelDisplay : false});
  }

  rejectRequestFinal = async () => {
    const dispatch = this.props.dispatch;
    if (await approveRejectDetailedReportRequest(this.props.loggedInUser, this.state.requestDetails.sparePartsUploadDetailsID, 3, this.state.finalizedCommentsByPartsSpec) === true) {
      dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'success', timeout: 3000, children: <span>{' Request rejected.'}</span> }] });
      this.setState(prevState  => ({
        requestDetails: {
          ...prevState.requestDetails, 
          statusName: 'Rejected'
        }
      }));
    } else {
      dispatch({ type: 'ADD_BANNER', banners: [{ bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Reject%20Request%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span>}] });
    }
    this.setState({approvalRejectionModelDisplay : false});
  }

  onCommentsProvided = (comments: string) => {
    this.setState({ finalizedCommentsByPartsSpec: comments });
  }

  toggleApprovalRejectionModelDisplay = (event: any) => {
    this.setState({ approvalRejectionModelDisplay : true });
  }

  updateLeadGeneratedInRequestDetails = () => {
    const requestDetails = {...this.state.requestDetails};
    requestDetails.leadGenerated = true;
    this.setState({requestDetails});
  }
  
  downloadReport = async () => {
    this.setState({waiting: true}, async () => {
      try {
        await DownloadReport(this.state.requestDetails.sparePartsUploadDetailsID, this.state.requestDetails.sparePartsUploadID, this.state.requestDetails.requestID);
      } catch (error) {
        console.log(error);
      }
      this.setState({waiting: false});
    });
  }
}

export const RequestLogDetails = withRouter(connect(mapStateToProps)(RequestLogDetailsComponent) as any);

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser
  };
}
